import { useCallback } from 'react'

import { getConfiguration } from 'services/config'

export const useSecureStorageTokenProvider = () => {
  const { secureStorageTokenUrl } = getConfiguration()

  const redirectToSecureStorageTokenProvider = useCallback(() => {
    window.location.replace(secureStorageTokenUrl)
  }, [secureStorageTokenUrl])

  return redirectToSecureStorageTokenProvider
}
